"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _ProductVisibilitySection = _interopRequireDefault(require("./ProductVisibilitySection"));

var _ProductSkilljar = _interopRequireDefault(require("@insided/destination/icons/ProductSkilljar"));

var _Types = require("../../Types");

var _common = require("@insided/shared/utils/common");

var _InfoV = _interopRequireDefault(require("@insided/control/icons/InfoV2"));

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Get all visible mega menu items (items with visibility: true)
 * Returns array of unique item identifiers for storage in selectedItems
 */
var getVisibleItemKeys = function getVisibleItemKeys(items) {
  return items.filter(function (item) {
    return item.visibility;
  }).map(function (item) {
    return (0, _utils.getItemUniqueId)(item);
  });
};
/**
 * Sync selected items with available items:
 * - If no items selected, default to all visible items (initial state only)
 * - Remove items that no longer exist in availableItems
 * - Preserve order of existing selected items
 * - DO NOT auto-add items that user intentionally removed
 */


var syncSelectedItems = function syncSelectedItems(currentSelectedItems, availableItems, previousAvailableItems) {
  var availableKeys = new Set(availableItems.map(function (item) {
    return (0, _utils.getItemUniqueId)(item);
  }));
  var visibleKeys = getVisibleItemKeys(availableItems); // If no items are selected, default to all visible items (initial state)

  if (currentSelectedItems.length === 0) {
    return visibleKeys;
  } // Filter out items that no longer exist in availableItems


  var validSelectedItems = currentSelectedItems.filter(function (key) {
    return availableKeys.has(key);
  }); // Only add items that are genuinely NEW to the mega menu (not items user removed)
  // A new item is one that exists in current availableItems but didn't exist in previous availableItems

  var newItems = [];

  if (previousAvailableItems) {
    var previousAvailableKeys = new Set(previousAvailableItems.map(function (item) {
      return (0, _utils.getItemUniqueId)(item);
    }));
    var validSelectedItemsSet = new Set(validSelectedItems); // Only add items that are visible AND new to availableItems (not previously available)

    newItems = visibleKeys.filter(function (key) {
      return !validSelectedItemsSet.has(key) && !previousAvailableKeys.has(key);
    });
  } // If no previous availableItems, don't auto-add anything (user may have intentionally removed items)
  // Combine: existing valid items (preserving order) + genuinely new items


  return [].concat((0, _toConsumableArray2.default)(validSelectedItems), (0, _toConsumableArray2.default)(newItems));
};

var ProductSharedVisibility = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductSharedVisibility, _Component);

  var _super = _createSuper(ProductSharedVisibility);

  function ProductSharedVisibility() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductSharedVisibility);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "previousAvailableItems", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "syncConfigWithAvailableItems", function () {
      var isInitialMount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var previousAvailableItems = arguments.length > 1 ? arguments[1] : undefined;
      var _this$props = _this.props,
          config = _this$props.config,
          availableItems = _this$props.availableItems,
          onChange = _this$props.onChange; // Use stored previous items if not provided

      var prevItems = previousAvailableItems || _this.previousAvailableItems;
      var hasChanges = false;
      var updatedConfig = {
        community: _objectSpread({}, config.community),
        skilljar: _objectSpread({}, config.skilljar)
      }; // Sync community items (skip for SJ Lite)

      if (!_common.common.isSkillJarLite()) {
        var syncedCommunityItems = syncSelectedItems(config.community.selectedItems, availableItems, isInitialMount ? undefined : prevItems);

        if (syncedCommunityItems.length !== config.community.selectedItems.length || syncedCommunityItems.some(function (key, index) {
          return key !== config.community.selectedItems[index];
        })) {
          updatedConfig.community.selectedItems = syncedCommunityItems;
          hasChanges = true;
        }
      } // Sync skilljar items — for SJ Lite, exclude default module items from available items


      var skilljarSyncItems = _common.common.isSkillJarLite() ? availableItems.filter(function (item) {
        return !_Types.SKILLJAR_LITE_HIDDEN_MENU_KEYS.includes(item.key);
      }) : availableItems;
      var prevSkilljarSyncItems = _common.common.isSkillJarLite() ? prevItems.filter(function (item) {
        return !_Types.SKILLJAR_LITE_HIDDEN_MENU_KEYS.includes(item.key);
      }) : prevItems;
      var syncedSkilljarItems = syncSelectedItems(config.skilljar.selectedItems, skilljarSyncItems, isInitialMount ? undefined : prevSkilljarSyncItems);

      if (syncedSkilljarItems.length !== config.skilljar.selectedItems.length || syncedSkilljarItems.some(function (key, index) {
        return key !== config.skilljar.selectedItems[index];
      })) {
        updatedConfig.skilljar.selectedItems = syncedSkilljarItems;
        hasChanges = true;
      } // Only call onChange if there are actual changes


      if (hasChanges) {
        onChange(updatedConfig);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleItemSelection", function (product, itemKey, checked) {
      var currentSelectedItems = _this.props.config[product].selectedItems;
      var newSelectedItems;

      if (checked) {
        // Add item if not already selected
        if (currentSelectedItems.includes(itemKey)) {
          return; // Already selected, no change needed
        }

        newSelectedItems = [].concat((0, _toConsumableArray2.default)(currentSelectedItems), [itemKey]);
      } else {
        // Remove item
        newSelectedItems = currentSelectedItems.filter(function (key) {
          return key !== itemKey;
        });
      }

      _this.props.onChange(_objectSpread(_objectSpread({}, _this.props.config), {}, (0, _defineProperty2.default)({}, product, _objectSpread(_objectSpread({}, _this.props.config[product]), {}, {
        selectedItems: newSelectedItems
      }))));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeItem", function (product, itemKey) {
      _this.toggleItemSelection(product, itemKey, false);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "reorderItems", function (product, reorderedItems) {
      _this.props.onChange(_objectSpread(_objectSpread({}, _this.props.config), {}, (0, _defineProperty2.default)({}, product, _objectSpread(_objectSpread({}, _this.props.config[product]), {}, {
        selectedItems: reorderedItems
      }))));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleMegaMenuVisible", function (product) {
      _this.props.onChange(_objectSpread(_objectSpread({}, _this.props.config), {}, (0, _defineProperty2.default)({}, product, _objectSpread(_objectSpread({}, _this.props.config[product]), {}, {
        megaMenuVisible: !_this.props.config[product].megaMenuVisible
      }))));
    });
    return _this;
  }

  (0, _createClass2.default)(ProductSharedVisibility, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // On mount, sync only if selectedItems is empty (initial state)
      // Don't auto-add items if user has already configured
      this.syncConfigWithAvailableItems(true);
      this.previousAvailableItems = (0, _toConsumableArray2.default)(this.props.availableItems);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Sync when availableItems change (new items added or removed from mega menu)
      if (prevProps.availableItems !== this.props.availableItems) {
        this.syncConfigWithAvailableItems(false, prevProps.availableItems);
        this.previousAvailableItems = (0, _toConsumableArray2.default)(this.props.availableItems);
      }
    }
    /**
     * Sync the config with available items:
     * - Initialize with all visible items if empty (initial state only)
     * - Remove items that no longer exist in availableItems
     * - Add only genuinely new items (items added to mega menu, not user-removed items)
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          config = _this$props2.config,
          availableItems = _this$props2.availableItems; // Check if Education, Skilljar, or Skilljar Lite (oauth2Integration) is enabled

      var isEducationOrSkilljarEnabled = _common.common.isModuleActive('oauth2Integration');

      var isSkillJarLite = _common.common.isSkillJarLite();

      var skilljarAvailableItems = isSkillJarLite ? availableItems.filter(function (item) {
        return !_Types.SKILLJAR_LITE_HIDDEN_MENU_KEYS.includes(item.key);
      }) : availableItems;
      return (0, _preact.h)("div", {
        className: "product-shared-visibility"
      }, !isSkillJarLite && [(0, _preact.h)(_ProductVisibilitySection.default, {
        key: "community-section",
        label: "Community",
        iconName: "community",
        megaMenuVisible: config.community.megaMenuVisible,
        selectedItems: config.community.selectedItems,
        availableItems: availableItems,
        onToggleMegaMenuVisible: function onToggleMegaMenuVisible() {
          return _this2.toggleMegaMenuVisible('community');
        },
        onItemSelectionChange: function onItemSelectionChange(itemKey, checked) {
          return _this2.toggleItemSelection('community', itemKey, checked);
        },
        onItemRemove: function onItemRemove(itemKey) {
          return _this2.removeItem('community', itemKey);
        },
        onItemsReorder: function onItemsReorder(reorderedItems) {
          return _this2.reorderItems('community', reorderedItems);
        }
      }), (0, _preact.h)("hr", {
        key: "community-divider",
        className: "product-shared-visibility-divider"
      })], isEducationOrSkilljarEnabled ? (0, _preact.h)(_ProductVisibilitySection.default, {
        label: "Skilljar",
        iconName: "skilljar",
        showHeader: !isSkillJarLite,
        megaMenuVisible: config.skilljar.megaMenuVisible,
        selectedItems: config.skilljar.selectedItems,
        availableItems: skilljarAvailableItems,
        onToggleMegaMenuVisible: function onToggleMegaMenuVisible() {
          return _this2.toggleMegaMenuVisible('skilljar');
        },
        onItemSelectionChange: function onItemSelectionChange(itemKey, checked) {
          return _this2.toggleItemSelection('skilljar', itemKey, checked);
        },
        onItemRemove: function onItemRemove(itemKey) {
          return _this2.removeItem('skilljar', itemKey);
        },
        onItemsReorder: function onItemsReorder(reorderedItems) {
          return _this2.reorderItems('skilljar', reorderedItems);
        }
      }) : (0, _preact.h)("div", {
        className: "product-shared-visibility-section"
      }, (0, _preact.h)("div", {
        className: "product-shared-visibility-section-header"
      }, (0, _preact.h)("div", {
        className: "product-shared-visibility-section-icon"
      }, (0, _preact.h)(_ProductSkilljar.default, {
        width: 40,
        height: 40
      })), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-title"
      }, "Skilljar")), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-info-message"
      }, (0, _preact.h)(_InfoV.default, null), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-info-text"
      }, "Skilljar module is not enabled. Please contact your admin to upgrade your plan to Customer Hub.", ' ', (0, _preact.h)("a", {
        href: "https://communities.gainsight.com/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "product-shared-visibility-section-info-link"
      }, "Learn more")))));
    }
  }]);
  return ProductSharedVisibility;
}(_preact.Component);

var _default = ProductSharedVisibility;
exports.default = _default;